
import React, { useEffect,useState,useRef,useLayoutEffect  } from 'react';
import {message,Badge,Tooltip} from 'antd'
import {api_dashboard_candtrace} from '../../../api';
import { ProTable } from '@ant-design/pro-components';
// import { UnorderedListOutlined,EditOutlined,EllipsisOutlined,PlusOutlined } from '@ant-design/icons';
// import { waitTime } from '../../../utils/global.js';

const screenHeight = document.body.clientHeight;
// const screenWidth = document.body.clientWidth;

const waitTime = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

const App = (props) => {
    const {tenant_id, candidate_id} = props;
    const actionRef = useRef();
    const [pagination, setPagination] = useState({current:1,pageSize:10,total:0});
    // let pagination = {current:1,pageSize:10,total:0};

    useEffect(() => {
      // setPagination({current:1,pageSize:10,total:0});
      // // waitTime(1000);
      // // pagination = {current:1,pageSize:10,total:0};
      // actionRef.current.reload();

        // 定义异步内部函数（useEffect 不能直接返回 async 函数，避免触发清理函数警告）
        const reloadTable = async () => {
          // 步骤1：调度 pagination 状态更新
          setPagination({ current: 1, pageSize: 10, total: 0 });
          
          // 步骤2：真正的延时 1000ms，等待状态更新生效
          await waitTime(500);
          
          // 步骤3：延时后执行表格重载，此时 pagination 已更新完成
          if (actionRef.current) { // 增加安全判断，避免 null 报错
            actionRef.current.reload();
          }
        };

        // 调用内部异步函数
        reloadTable();
        
    }, [tenant_id, candidate_id]);

  // 定义一个单独的函数组件来处理文本溢出逻辑
  const OverflowText = ({ text, color, status }) => {
    // console.log('invitation_status record - ',text,color,status)
    const ref = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);

    useLayoutEffect (() => {
        if (ref.current) {
            const { offsetWidth, scrollWidth } = ref.current;
            console.log('invitation_status record - ',ref,offsetWidth,scrollWidth)
            setIsOverflow(scrollWidth > offsetWidth);
        }
    }, [text]);

    return (
        <div>
            {isOverflow ? (
                <Tooltip title={text}>
                    <Badge status={status} color={color} text={<span ref={ref} style={{ display: 'inline-block' }}>{text}</span>} />
                </Tooltip>
            ) : (
                <Badge status={status} color={color} text={<span ref={ref}>{text}</span>} />
            )}
        </div>
    );
  };

    let columns = [
        {
          title: '候选人ID',
          dataIndex: 'candidate_id',
          key: 'candidate_id',
          search: false,
          width:80,
        },
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          order:3,
          width: 100,
          ellipsis: true,
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
        },
        {
          title: '手机',
          dataIndex: 'phone',
          key: 'phone',
          width: 100,
          // search: false,
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
        },
        {
          title: '所属工单ID',
          dataIndex: 'work_order_id',
          search:false,
          key:"work_order_id",
          width: 220,
          ellipsis: true,
        },
        {
          title: '任务溯源码',
          dataIndex: 'code',
          search:false,
          key:"code",
          width: 120,
          ellipsis: true,
        },
        {
          title: '任务状态',
          dataIndex: 'task_status',
          key:"task_status",
          search:false,
          // order:5,
          width: 110,
          ellipsis: true,
          // valueType: 'select',
          // valueEnum: interviewEnum,
          // formItemProps: {
          //   labelCol: { span: 8 }, // 设置搜索项名称的宽度
          // },
        },
        {
          title: '优先选项',
          dataIndex: 'prior_option_name',
          key:"prior_option_name",
          search:false,
          // order:4,
          width: 110,
          ellipsis: true,
          // valueType: 'select',
          // valueEnum: positionEnum,
          // formItemProps: {
          //   labelCol: { span: 8 }, // 设置搜索项名称的宽度
          // },
        },
        {
          title:'可用面试时间',
          dataIndex: 'avl_intv_time_name',
          key:"avl_intv_time_name",
          search:false,
          // order:1,
          width: 150,
          // fieldProps: {
          //   picker: "date",
          //   format:'YYYY-MM-DD',
          //   allowClear:true,
          //   // defaultValue:[moment(startTime), moment(endTime)]
          // },
          // formItemProps: {
          //   labelCol: { span: 8 }, // 设置搜索项名称的宽度
          // },
          // render: (_,record) => {
          //   return record.order_creat_time
          // }
        },
        // {
        //   title: '面试官回复工单可用时间记录',
        //   dataIndex: 'order_interview_reply',
        //   key:"order_interview_reply",
        //   search:false,
        //   // order:2,
        //   width: 120,
        //   // ellipsis: true,
        //   // valueType: 'select',
        //   // valueEnum: orderCreatUserEnum,
        //   // formItemProps: {
        //   //   labelCol: { span: 8 }, // 设置搜索项名称的宽度
        //   // },
        // },
        // {
        //   title: '面试官确认候选人新时间状态',
        //   dataIndex: 'cand_interview_confirm',
        //   key: 'cand_interview_confirm',
        //   search: false,
        //   width: 120,
        // },
        // {
        //   title: '面试官确认候选人新时间邮件',
        //   dataIndex: 'cand_interview_reply',
        //   key: 'cand_interview_reply',
        //   search: false,
        //   width: 120,
        // },
        {
          title: '外呼执行记录',
          dataIndex: 'call_record',
          key: 'call_record',
          search: false,
          width: 150,
        },
        {
          title: '通话结束情况记录',
          dataIndex: 'call_drop',
          key: 'call_drop',
          search: false,
          width: 150,
        },
        {
          title: '身份确认记录',
          dataIndex: 'identity_confirm',
          key: 'identity_confirm',
          search: false,
          width: 150,
        },
        {
          title: '方便性判断',
          dataIndex: 'convenience_judge',
          key: 'convenience_judge',
          search: false,
          width: 150,
        },
        {
          title: '形式确认',
          dataIndex: 'format_confirm',
          key: 'format_confirm',
          search: false,
          width: 150,
        },
        {
          title: '时间撮合记录',
          dataIndex: 'time_slot',
          key: 'time_slot',
          search: false,
          width: 150,
        },
        {
          title: '面试官确认候选人新时间邮件',
          dataIndex: 'cand_newtime_reply',
          key: 'cand_newtime_reply',
          search: false,
          width: 120,
        },
        {
          title: '签到记录',
          dataIndex: 'signin_record',
          key: 'signin_record',
          search: false,
          width: 150,
        },
      ];

    return (
      <div>
          <ProTable
            headerTitle={""}
            columns={columns}
            actionRef={actionRef}
            rowKey="candidate_id"
            cardBordered
            defaultSize="small"
            search={candidate_id?false:true}
            request={async (params, sort, filter) => {
              console.log(params,sort, filter);
              // await waitTime(2000);
              var tableData = [];
              // if(params.phone || params.name){
                params.tenant_id = tenant_id;
                params.candidate_id = candidate_id;
                var res = await api_dashboard_candtrace(params);
                console.log('api_dashboard_candtrace-res-----------------', res);
                if(res.data.code == 9){
                  waitTime(100);
                  tableData = res.data.list;
                  setPagination({current:parseInt(res.data.pageinfo.current), pageSize:parseInt(res.data.pageinfo.pageSize), total:parseInt(res.data.pageinfo.total)})
                  // pagination = {current:parseInt(res.data.pageinfo.current), pageSize:parseInt(res.data.pageinfo.pageSize), total:parseInt(res.data.pageinfo.total)};
                }else
                  message.error(res.data.msg);
              // }

              return {
                data: tableData,
                // current: res.data.pageNo,
                // pageSize: res.data.pageSize,
                success: true,
                // total: res.data.totalRows,
              };
            }}
            options={{
              reload: false, // 去掉刷新按钮
              density: false, // 去掉密度按钮
              setting: true, // 保留列设置按钮
              setting: {
                listsHeight: 400,
              },
            }}
            style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'auto',overflowY: 'auto'}}  
            scroll={{x:1500}}
            columnsState={{
              persistenceKey: 'pro-table-candidate',
              persistenceType: 'localStorage',
              onChange(value) {
                console.log('value: ', value);
              },
            }}

            // form={{
            //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
            //   syncToUrl: (values, type) => {
            //     if (type === 'get') {
            //       return {
            //         ...values,
            //         created_at: [values.startTime, values.endTime],
            //       };
            //     }
            //     return values;
            //   },
            // }}
            pagination={{
              // pageSizeOptions: [10, 20, 50, 100, pagination.total],
              showSizeChanger: true,
              pageSize: pagination.pageSize,
              current:pagination.current,
              total:pagination.total,
              onChange: (page) => console.log(pagination),
            }}
      
                  // dateFormatter="string"

            toolBarRender={() => []}
          />

      </div>

    )
}

export default App